import React, { useEffect } from "react";

import { locale, addLocale } from "primereact/api";
import es from "./data/Calendar.json";
// import {HashRouter as Router} from 'react-router-dom'
import { RouterProvider } from "react-router-dom";
// import Layout from "./Templates/Layout";
import { RootRouter } from "App/routes/UpdateRouterV6";
import useAxios from "App/Hooks/useAxios";

function App() {
  const ListaRutas = useAxios("GET", "/api/lista-rutas/");

  useEffect(() => {
    addLocale("es", es);
    locale("es");
    return () => {};
  }, []);

  return <RouterProvider router={RootRouter(ListaRutas.datos)} />;
}
export default App;
